// extracted by mini-css-extract-plugin
export default {"root":"app-docker-components-container-quick-actions-ContainerQuickActions-module__root"};